import { render, staticRenderFns } from "./ComponentClaimStep.vue?vue&type=template&id=2969893a"
import script from "./ComponentClaimStep.vue?vue&type=script&lang=js"
export * from "./ComponentClaimStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports